import { Tabs } from "antd";
import React from "react";

export const items = [
  {
    label: "Payment Gateway Refund Policy",
    key: "payment_gateway_refund_policy",
    children: (
      <div className="policy_section payment_gateway_refund_policy">
        <h3 className="policy_header">Payment Gateway Refund Policy</h3>
        <p className="query_section">
          <ol type="1">
            <li>
              In the event of a successful cancellation request, the refund
              amount will be credited to the Source Account used for the top-up,
              loading, or reloading transaction.
            </li>
            <li>
              If you encounter a situation where you have made a payment but
              have not received the top-up on your Card, kindly reach out to Us
              at prepaid.{" "}
              <a href="mailto:prepaid.service@nsdlbank.co.in">
                service@nsdlbank.co.in
              </a>{" "}
              with your order number or call Us at our customer care-number
              [022-42022190]. We will make every effort to resolve the issue as
              quickly as possible. Please note that no refund shall be issued
              for the successful Transaction.{" "}
            </li>
            <li>
              Once you inform Us with the order number, we will promptly
              initiate your refund request with the Payment Channel Service
              Provider. The refund will be processed within a reasonable
              timeframe, typically within 3-7 Business Days from the date of the
              request. In case of technical issues or delays caused by
              third-party payment gateways or Issuer or banks, the refund
              processing time may vary, and we shall not be liable for any such
              delays beyond our control.{" "}
            </li>
            <li>
              Non-Refundable Scenarios: Once a Transaction is successfully
              processed, the amount loaded onto the Card becomes non-refundable.{" "}
            </li>
            <li>
              If you have any further queries or concerns, please feel free to
              contact Us at care{" "}
              <a href="mailto:prepaid.service@nsdlbank.co.in">
                prepaid.service@nsdlbank.co.in
              </a>{" "}
              with your order number or call our customer care number
              [022-42022190].{" "}
            </li>
            <li>
              {" "}
              Non-Refundable Scenarios: Once a Transaction is successfully
              processed, the amount loaded onto the Card becomes non-refundable.{" "}
            </li>
            <li>
              Exceptions -
              <ul style={{ paddingLeft: "30px" }}>
                <li>
                  In the case of proven fraudulent or unauthorized transactions,
                  we reserve the right to investigate and refund the amount to
                  the affected the User as per the Applicable Laws and
                  regulations.{" "}
                </li>
                <li>
                  Refunds for any Transactions conducted in violation of our
                  Terms and Conditions or any fraudulent activities will not be
                  processed, and appropriate legal actions shall be taken.
                </li>
              </ul>
            </li>
          </ol>
        </p>
      </div>
    ),
  },
  {
    label: `Terms & Conditions`,
    key: "1",
    children: (
      <div className="policy_section grievance_policy">
        <h3 className="policy_header">
          Terms and Conditions for Use Of PayCraft Products
        </h3>
        <p>
          PayCraft Solutions Private Limited ("PayCraft") has developed a
          Software Application (as defined below) and is also hosting PayCraft
          Sites (collectively referred to as "Platform") by way of which
          PayCraft provides payment solutions and payments related products &
          other related product or services to customers and businesses
          ("Customer") through its platform or with use of its products or
          services and also facilitates the Customer in providing
          online/offline/ POS payments using /debit cards, net banking, bank
          transfers and various other acceptable modes of Payment Mechanism
          options provided by PayCraft. The Customer agrees to avail PayCraft
          Services and for payment to Customer's Vendors/Partners or Utility
          bill payments or acceptance of payments from its Vendors/Partners.
          Your use of the PayCraft Services implies that you have read,
          understood and agreed to abide by following disclaimer and terms &
          conditions ("Terms & Conditions''). These Terms & Conditions together
          with our Privacy Policy as provided on{" "}
          <a href="https://emsweb.paycraftsol.com">
            {" "}
            https://emsweb.paycraftsol.com
          </a>{" "}
          the PayCraft Sites ("Privacy Policy") govern your usage of the
          PayCraft Services.
        </p>
        <h4>Definitions</h4>
        <p className="query_section">
          <ol type="1">
            <li>
              <strong>"Acquiring Banks"</strong> shall mean various banks,
              financial institutions, Card Associations, payment system
              providers who are defined and licensed under the Payment and
              Settlement Systems Act, 2007 and other software providers who are
              in the business of providing information technology services,
              including but not limited to, POS terminals, internet-based
              electronic commerce, internet payment gateway, and electronic
              software distribution services.
            </li>
            <li>
              <strong>"Acquiring Bank Services"</strong> shall mean the
              POS/payment gateway system and services provided by the Acquiring
              Banks such as to (i) route internet/POS terminal-based Valid Card
              transactions; (ii) offer various facilities through the
              internet/POS terminals, including Net Banking facilities; (iii)
              provide Authentication and Authorization from Card
              Associations/Issuing Institutions or other third-party
              clearinghouses; and (iv) provide settlement facilities in respect
              of payment instructions initiated by the customers.
            </li>
            <li>
              <strong>"Applicable Law"</strong> shall mean all laws, ordinances,
              judgments of any court or government authority, administrative or
              regulatory including notifications or guidelines issued by Reserve
              Bank of India.
            </li>
            <li>
              <strong>"Authentication"</strong> shall mean the process by which
              the Customer's identification is authenticated by the
              Acquiring/Issuing Banks.
            </li>
            <li>
              <strong>"Authorization"</strong> shall mean the process by which
              the Issuing Institution and/or banks and/or the relevant Card
              Association electronically or otherwise convey the approval of the
              charge (i.e. if the Customer has a Valid Card and/or the required
              limit/debit limit to pay the Customer Charge requested) on a
              Transaction being undertaken by a Customer.
            </li>
            <li>
              <strong>"Business Days"</strong> shall mean (i) A day other than
              Saturday or Sunday or (ii) a day other than on which the Banks in
              India and/or Reserve Bank of India are closed for business /
              clearing, or (iii) a day other than on which normal business in
              India could not be transacted due to storms, floods, bandhs,
              strikes, or (iv) any days other than declared by PayCraft and/or
              Acquiring/Issuing Bank as a Holidays, etc.
            </li>
            <li>
              <strong>"Card Association(s)"</strong> shall mean any of Visa,
              MasterCard, Visa Electron, Mercury, Maestro, Rupay, Diners,
              American Express or any other card association as may be specified
              by PayCraft from time to time.
            </li>
            <li>
              <strong>"Card Association Rules"</strong> shall mean the written
              rules, regulations, releases, guidelines, processes,
              interpretations, and other requirements (whether contractual or
              otherwise) imposed or adopted by any Card Association.
            </li>
            <li>
              <strong>"Chargeback"</strong> shall mean the approved and settled
              card or net banking Transactions which are raised or disputed by
              the valid cardholder or valid account holder to the Issuing bank
              or its bank and at any time reversed or debited (shall also
              include similar debits to PayCraft’s bank accounts, if any) by the
              Acquiring and/or Issuing Bank for any reason whatsoever, together
              with the bank fees, penalties, and other charges incidental
              thereto if any.
            </li>
            <li>
              <strong>"Commercial Payment Schedule"</strong> shall mean a
              separate payment schedule agreed between the Customer and PayCraft
              setting out the Service Fee (defined below), the set-up fee,
              annual maintenance charges, security deposit and any other charges
              payable by the Customer for the PayCraft Services.
            </li>
            <li>
              <strong>"Confidential Information"</strong> shall mean any and all
              written, oral or other tangible or intangible form of information,
              discoveries, ideas, concepts, know-how (whether patentable or
              copyrightable or not), research, development, designs, drawings,
              blueprints, diagrams, models, samples, flow charts, data, computer
              programs, disks, diskettes, tapes, algorithms, software programs,
              marketing plans or techniques, technical, financial, or business
              information" trade secrets which include but are not restricted to
              any portion or scientific or technical or proprietary information,
              design, process, procedure, formula or improvement which is not
              generally available to the public as delivered by PayCraft
              ("Disclosing Party") to the other Party ("Receiving Party") within
              the framework of these Terms and Conditions or resulting
              therefrom. Confidential Information shall also include the details
              of Customers, available on the PayCraft Platform.
            </li>
            <li>
              <strong>"Customer Charges"</strong> shall have the meaning set out
              under Paragraph 6 (iii).
            </li>
            <li>
              <strong>"Customer/Corporate/Enterprise"</strong> shall mean an
              individual or legal entity, who/which purchases/utilize or sells
              Products or Services from or to the Vendors/Partners/PayCraft,
              payment of which gets directed to Payment Mechanism provided by
              PayCraft under PayCraft Services.
            </li>
            <li>
              <strong>"Customer/Corporate/Enterprise Bank Account"</strong>{" "}
              shall mean a bank account or /debit/ prepaid/ cash card account of
              the Customer with Issuing Institution.
            </li>
            <li>
              <strong>
                "Customer/Corporate/Enterprise Charge/Transaction Amount"
              </strong>{" "}
              shall mean the sale price of the products purchased or sold by the
              Customer plus the shipping charge (if any) or in case of utility
              the actual Bill amount presented by Utility biller for services
              utilized by the customer/corporate/enterprise and all other taxes,
              duties, costs, charges and expenses in respect of the
              Products/payment that are to be paid by the Customer or Vendors,
              as the case may be.
            </li>
            <li>
              <strong>"Customer Data"</strong> shall mean data and information
              that Customer submits to PayCraft or to PayCraft Sites or on the
              Platform in connection with the Services, including information
              stored in or processed through the PayCraft Platform. However,
              such data or information shall not include the data or information
              which is/are in the public domain.
            </li>
            <li>
              <strong>"Financial Institution"</strong> shall mean one or more of
              'PayCraft' approved banks or financial institutions including
              NBFC.
            </li>
            <li>
              <strong>"Issuing Institution or Issuing bank"</strong> shall mean
              a bank or financial institution or other legal entity, with which
              the Customer or Vendor (as the case may be) has a Net Banking
              account and/or which has issued the Valid Card to the Customers or
              Vendors.
            </li>
            <li>
              <strong>"Customer PayCraft Account"</strong> shall mean the
              Customer account maintained with PayCraft in order to provide the
              PayCraft Services to the Customer.
            </li>
            <li>
              <strong>"Vendor Bank Account"</strong> shall mean the bank account
              maintained by Vendor for payment, which Customer nominates for
              settlement of Vendor Settlement Amount and the details of which
              are provided to PayCraft.
            </li>
            <li>
              <strong>"Net Banking Account"</strong> shall mean the facility and
              internet account provided by the Issuing Institution to Customers
              or Vendors holding a bank account with the Issuing Institutions
              specified by PayCraft from time to time. Provided that the bank
              account is not listed in current warning or restricted bank
              account bulletins or notices.
            </li>
            <li>
              <strong>"Nodal Account"</strong> shall mean a non-operative
              account held by PayCraft with any of the banks for the purpose of
              pooling the monies collected from Customers on behalf of the
              Vendors/Partners/Customer and facilitating the transfer of these
              funds in final settlement to the Vendors/Partners/Customer (after
              deducting Service Fee or as per arrangement between Customer & its
              Vendor), pursuant to RBI notification
              DPSS.CO.PD.No.1102/02.14.08/2009-10, dated 24/11/2009 or any other
              RBI notifications amended from time to time.
            </li>
            <li>
              <strong>"Nodal Bank"</strong> shall mean the bank(s) designated by
              PayCraft for the purpose of pooling the funds collected from
              Customers on behalf of the Vendor/Partners/Customer and
              facilitating the transfer of these funds in final settlement to
              the Vendor/Partners/Customer (after deducting Service Fee or as
              per arrangement with Corporate, pursuant to RBI notification
              DPSS.CO.PD.No.1102/02.14.08/2009-10, dated 24/11/2009 or any other
              RBI notifications or guidelines amended from time to time.
            </li>
            <li>
              <strong>"One Click Checkout"</strong> shall mean the facility
              provided to the Customers to use its Valid Card details with
              PayCraft designated industry-standard compliant third party for
              payment with a single click.
            </li>
            <li>
              <strong>"Outstanding Amount"</strong> shall mean the amount
              payable by the Customer or Vendor to PayCraft, Acquiring and/or
              Issuing Banks towards Chargebacks or any fees, penalty or other
              payments owed to PayCraft by the Customer or Vendor; and any
              claims, cost or expenses as a result of the proceedings filed
              against PayCraft and/or Acquiring and/or Issuing Banks by the
              Customers or any third Party.
            </li>
            <li>
              <strong>"Payment Mechanism"</strong> shall mean the mechanism of
              making payment by utilizing the internet/POS terminal/Batch
              Auth/Batch Upload/any other form of facilities of various
              Acquiring and/or Issuing Banks, Card Associations, card payment
              systems and through such other modes and mechanisms of payment and
              delivery as may be notified by PayCraft from time to time.
            </li>
            <li>
              <strong>"PayCraft Services"</strong> shall have the meaning
              ascribed to it under "Services" as defined herein and more
              particularly described in the Scope of Work hereto provided
              through PayCraft Services Products.
            </li>
            <li>
              <strong>"PayCraft Services Product"</strong> shall mean the
              PayCraft products by means of which PayCraft provides PayCraft
              Services. The Customer will be provided with the PayCraft Services
              Product in the manner described in the Terms and Conditions.
            </li>
            <li>
              <strong>"PayCraft Sites"</strong> shall mean the websites provided
              by PayCraft by means of which PayCraft provides PayCraft Services
              to the Customers and Vendors.
            </li>
            <li>
              <strong>"Products"</strong> shall mean goods and/or services
              offered for sale by the Customer or Vendor or PayCraft on its
              Sites or through other mediums.
            </li>
            <li>
              <strong>"POS Terminal"</strong> shall mean a point of sale device
              placed in a Vendor/Corporate location which is connected to the
              acquiring bank system via telephone lines and is designed to
              authorize, record and settle data by electronic means for all
              sales transactions with acquiring banks.
            </li>
            <li>
              <strong>"RBI"</strong> shall mean the Reserve Bank of India.
            </li>
            <li>
              <strong>"Settlement Amount"</strong> shall mean final amount to be
              settled and transferred to the Vendor Bank Account or
              Customer/Service provider Bank Account (as the case may be) after
              due collection of charges/fees payable to PayCraft under these
              Terms and Conditions.
            </li>
            <li>
              <strong>"Services"</strong> shall mean PayCraft facilitating
              Payments and payments related products & other related products or
              services to customers and businesses through its platform or with
              use of its platform or services and also Financial Supply Chain
              Management through an online platform or anything which uses
              PayCraft Services Product.
            </li>
            <li>
              <strong>"Vendor/Partner/Vendors/Partners"</strong> shall mean the
              supplier or purchaser of goods or services to or from Customer.
            </li>
            <li>
              <strong>"Territory"</strong> shall mean boundaries within India.
            </li>
            <li>
              <strong>"Transaction"</strong> shall mean the payment for the
              purchase or sale of goods and services by Customer or PayCraft,
              where the delivery of the goods or services associated with such
              transactions is immediate or simultaneous to the payment or where
              the payment is being made after the goods or services have been
              delivered and consumed. 'Transactions' shall not include any
              transaction where the payment is made in advance while the
              goods/services are delivered/performed in a deferred manner.
            </li>
            <li>
              <strong>"Work Orders"</strong> shall mean a request by Customer to
              PayCraft for access to the PayCraft Platform and provisioning of
              Services as per the terms and conditions stated in these Terms and
              Conditions.
            </li>
            <li>
              <strong>"Valid Card"</strong> shall mean any unexpired card,
              prepaid or debit card which is issued by an Issuing Institution
              designated to issue a Visa, MasterCard, RuPay, American Express,
              Visa Electron, or a Maestro or cash card, pre-paid card, or other
              card as may be specified by PayCraft from time to time. Provided
              that the card is not listed in current warning or restricted card
              bulletins or notices and bears the signature of the person in
              whose name the card is issued.
            </li>
          </ol>
        </p>
        <h4>Services</h4>
        <p className="query_section">
          <ol>
            <li>
              PayCraft facilitates PayCraft Services between the Customer and
              Vendors/ Partners/ Utility Solution providers through the PayCraft
              Platform. It also enables the Customers or Vendors to make payment
              of Transaction Amount through PayCraft Platform for Transactions
              carried through the Payment Mechanisms using Acquiring and/or
              Issuing Bank's Services. Once the payment instruction is
              Authenticated and Authorized by the respective Acquiring and/or
              Issuing Bank in respect of a Transaction, the Acquiring and/or
              Issuing Bank will transfer such approved Transaction Amount to the
              Nodal Account. The Customer hereby directs and authorizes PayCraft
              to receive, hold, disburse and settle the Transaction Amount in
              accordance with and subject to the Terms and Conditions. PayCraft
              shall provide the initial set-up and integration and deployment of
              'PayCraft' Platform at the Customer's sites, including training to
              Customer personnel.{" "}
            </li>
            <li>
              PayCraft facilitates the issuance of corporate prepaid cards to
              its corporate Customers where such cards are issued by its partner
              banks ("Partner Banks"). In its arrangement with the Partner
              Banks, the Partner Banks issue co-branded cards and PayCraft
              undertakes marketing, promotion and distribution services in
              relation to these cards, for the purpose of facilitating the
              issuance of the prepaid cards. Notwithstanding anything stated
              herein, it is hereby clarified that PayCraft shall not undertake
              any KYC verification process or decision in relation to the
              approval or disapproval of the issuance of the cards to the users
              and the same shall be undertaken directly by the Partner Bank. Any
              KYC verification and the decision in relation to the issuance of
              the cards shall be the sole responsibility of the Partner Bank and
              PayCraft shall not be liable for the same in any manner.{" "}
            </li>
            <li>
              PayCraft also facilitates the issuance of prepaid cards to the
              employees of its corporate Customers, wherein the Customers pay
              the amount up to the assigned limit on each card in advance and
              PayCraft facilitates the issuance of such cards, through its
              arrangement with the Partner Bank(s). These corporate cards can be
              customized as per the request of the Customers. The Partner
              Bank(s) issue the card and process all transactions requested by
              the Customers. PayCraft shall undertake marketing, distribution
              and promotion of the card. Please read the terms and conditions
              governing the cards issued by the Partner Bank, where such
              issuance is facilitated by PayCraft, available at PayCraft.com and
              the terms and conditions governing the prepaid card issued by the
              Partner Bank and facilitated by PayCraft, available at
              PayCraft.com{" "}
            </li>
            <li>
              PayCraft provides expense and spend management dashboard to its
              Customers which shall provide for management of all spends,
              including payables, receivables, and expenses, including employee
              expenses ("Spend Management Service"). Every Customer on the
              Platform gets a unique login on sign up and/or on issuance of the
              card by the Partner Bank through PayCraft, which enables the spend
              management dashboard for all such Customers where any transaction
              occurring on their card or on Platform is fed in real time onto
              the spend management dashboard with details such as value,
              merchant, time, etc.{" "}
            </li>
            <li>
              PayCraft also provides a dashboard which allows the Customers to
              track the number of days for which payments have been outstanding
              and other relevant information, thereby allowing them to track
              their spends. PayCraft further provides a dashboard which allows
              the Customers to track any payment due to the Customers, the
              number of days for which payments have been outstanding and other
              relevant information.{" "}
            </li>
          </ol>
        </p>
        <h4>Eligibility and Access </h4>
        <p>
          PayCraft Services is not available to minors i.e. persons under the
          age of 18 (eighteen) years or to any users suspended or removed from
          the PayCraft Platform for any reason whatsoever. Customer represents
          that he/she is of legal age to form a binding contract and is not a
          person barred from using or accessing the PayCraft Platform under the
          applicable laws of India. You may use the PayCraft Service only in
          compliance with these Terms and all applicable local, state, national,
          and international laws, rules and regulations. PayCraft Services is
          always evolving and the form and nature of the PayCraft Services may
          change from time to time without prior notice to the Customer. In
          addition, PayCraft may stop (permanently or temporarily) providing
          PayCraft Services (or any features within PayCraft Services) to you or
          the Customers generally and may not be able to provide you with prior
          notice. PayCraft also retains the right to create limits on use,
          storage and features at its sole discretion at any time without prior
          notice to you.
        </p>
        <h4>User Account, Passwords and Security </h4>
        <p className="query_section">
          <ol type="1">
            <li>
              In order to use the PayCraft Service, you will have to register on
              the PayCraft Platform by providing certain details about yourself,
              including your name, mobile number, email address and such other
              details as may be required and create an account (“Account”).
              Additionally, Customers are prohibited from selling, trading, or
              otherwise transferring their Account to another party.
            </li>
            <li>
              Customer shall ensure and confirm that the Account information
              provided by them is complete, accurate and up-to-date. If there is
              any change in the Account information, you shall promptly update
              your Account information on the PayCraft Platform. If you provide
              any information that is untrue, inaccurate, not current or
              incomplete (or becomes untrue, inaccurate, not current or
              incomplete), or if PayCraft has reasonable grounds to suspect that
              such information is untrue, inaccurate, not current or incomplete,
              PayCraft has the right to suspend or terminate your Account and
              refuse any and all current or future use of the PayCraft Service
              (or any portion thereof) at its discretion, in addition to any
              right that PayCraft may have against you at law or in equity, for
              any misrepresentation of information provided by you.{" "}
            </li>
            <li>
              Customer is responsible for maintaining the confidentiality of the
              Account information, safeguarding the password or credentials that
              you use to access the Service and for any activities or actions
              under your Account. You are encouraged to use "strong" passwords
              (passwords that use a combination of upper and lower-case letters,
              numbers and symbols) with your Account and with other accounts
              that you may connect to your Account (such as Facebook, Twitter or
              your email).
            </li>
            <li>
              Customer agrees to (1) immediately notify PayCraft of any
              unauthorized use of your Account information or any other breach
              of security, and (2) ensure that you exit from your Account at the
              end of each session. PayCraft cannot and will not be liable for
              any loss or damage arising from your failure to comply with the
              above requirements. Further, PayCraft will not be liable for any
              loss that you may incur as a consequence of unauthorized use of
              your Account either with or without your knowledge.
            </li>
            <li>
              Customer may be held liable for losses incurred by PayCraft or any
              other user of or visitor of the PayCraft Platform due to
              authorized or unauthorized use of your Account as a result of your
              failure in keeping your Account information secure and
              confidential.
            </li>
            <li>
              {" "}
              Customer may terminate their account at any time by writing to
              PayCraft at{" "}
              <a href="mailto:support@PayCraft.com">support@PayCraft.com</a>
            </li>
          </ol>
        </p>
        <h4>Customer Representations, Warranties and Covenants</h4>
        <p className="query_section">
          <ol type="1">
            <li>
              Customer shall provide all the information and details required by
              PayCraft and fill all forms as may be required by PayCraft
            </li>
            <li>
              Customer shall also provide such declarations as specified by
              PayCraft and required by the Bank in the form and manner as may be
              specified by PayCraft.
            </li>
            <li>
              Customer shall be responsible for accuracy of information provided
              by the Customer under the forms specified above.
            </li>
            <li>
              He/she will provide appropriate infrastructure for access of the
              PayCraft Platform provided by PayCraft, on its platform.
            </li>
            <li>
              Customer will ensure that the PayCraft Platform is operated by
              authorized identified competent personnel in accordance with the
              furnished operating instructions and are used only for the{" "}
            </li>
            <li>
              Customer shall be solely responsible for the authentication of any
              information and legitimacy of Customer's Vendors.{" "}
            </li>
            <li>
              Customer shall be solely liable for payment due to the Financial
              Institutions including any charges in connection with the same.
              PayCraft will act purely on the instructions of the Customer as
              per the information provided by the Customer.{" "}
            </li>
            <li>
              Customer will be responsible to identify and clearly articulate
              the Vendors/ Utility /GST/ Rental service provider who needs to be
              paid.{" "}
            </li>
            <li>
              Customer is responsible and accountable for all the information
              and due diligence of its Vendors/ Utility Service Provider/
              Partners.{" "}
            </li>
            <li>
              tomer understands and acknowledges that the Platform permits only
              transactions where delivery of the goods or services associated
              with such transactions is immediate or simultaneous to the payment
              or transactions where payment is being made after the
              goods/services have been delivered and consumed (“DvP
              Transaction”). You undertake that you shall use the PayCraft
              Platform only for performing DvP Transactions and shall not
              perform any transactions where the payment is made in advance
              while the goods/services are delivered/performed in a deferred
              manner.
            </li>
          </ol>
        </p>
        <h4>
          Approval and registration To Avail PayCraft Services/Acquring AND/OR
          Issuing Bank Services{" "}
        </h4>
        <p>
          The customer shall disclose the exact business category/business
          sub-category for which the customer will be using the PayCraft
          Services and shall only avail the PayCraft Services through approved
          mechanism by PayCraft. In order to use the PayCraft Services for any
          other purpose, the Customer shall notify PayCraft in writing of such
          change and such change will be subject to approval by PayCraft. The
          Customer understands that in order to avail Services, the Customer
          must be approved by and registered with PayCraft, the Acquiring and/
          or Issuing Banks and/or Nodal Bank. Any undertaking with respect to
          the PayCraft Services under these Terms and Conditions shall be
          subject to PayCraft's, the Acquiring and/or Issuing Bank's and/or
          Nodal Bank's approval and completion of the registration process. The
          Customer further understands and acknowledges that PayCraft, the
          Acquiring and/or Issuing Banks and/or Nodal Bank have the right to
          withdraw their approval/consent at any time prior to or after
          commencement of the PayCraft Services.{" "}
        </p>
        <h4>Fees And Payment Terms </h4>
        <p className="query_section">
          <ol type="1">
            <li>
              In consideration for PayCraft Services, the Customer agrees to pay
              PayCraft, service fee as may be agreed between the PayCraft and
              the Customer in writing (“Service Fee”), which can be deducted by
              PayCraft from the Transaction Amount in respect of each completed
              Transaction. The Customer also agrees to pay PayCraft an
              additional Service Fee as agreed in writing which could be flat,
              monthly or annual fees. PayCraft reserves the right to revise the
              service fee periodically, and PayCraft will intimate the Customer
              of any such change within reasonable time.
            </li>
            <li>
              Any other amounts payable by the Customer such as the set-up fee,
              annual maintenance charges, security deposit and any other charges
              ("Customer Charge") shall be agreed between the Customer and
              PayCraft in writing.
            </li>
          </ol>
        </p>
        <h4>Payment Arrangement </h4>
        <p>
          PayCraft shall endeavour to instruct the Nodal Bank to transmit the
          Settlement Amount from the Nodal Account to the Vendor's Bank Account
          or in Customer Bank Account in case the Customer is accepting payments
          from Vendors within the time-period prescribed by RBI commencing from
          date of Completion of Transaction as separately mutually agreed. If
          the Customer opts for PayCraft Services using PayCraft Services
          Product, the Customer understand that the Transaction shall be
          completed only upon receipt of the Transaction Amount in the Nodal
          Account from the Acquiring and/or Issuing Banks and reconciliation of
          the same by the Acquiring and/or Issuing Banks, PayCraft and the Nodal
          Bank ("PayCraft Completion of Transaction"). The transmission of the
          Settlement Amount to the Vendor Bank/Utility/GST/Rental Service
          provider bank account shall be subject to reconciliation of the
          Customer Charge by the Acquiring and/or Issuing Banks, PayCraft and
          the Nodal Bank after actual receipt of Transaction Amount in the Nodal
          Account. The Customer shall be solely responsible for all payments
          with respect to refunds and Chargebacks and PayCraft shall not be
          liable for any claims, disputes, penalties which may arise in
          connection with such refunds or Chargebacks. The Customer agrees to
          indemnify PayCraft in respect of any claims, disputes, penalties,
          costs and expenses arising directly or indirectly in relation to
          refunds or Chargebacks for all Transactions initiated and instructed
          through the PayCraft Platform or through other medium. Notwithstanding
          anything contained herein, the Customer hereby fully confirms and
          agrees that PayCraft, Acquiring and/or Issuing Bank and Nodal Bank
          reserve the right to reject payments with respect to any Customer
          Charge for reasons including but not limited to unlawful,
          unenforceable, doubtful or erroneous Transaction, Chargeback, refund,
          fraud, suspicious activities, card Authentication and Authorization
          issues, overpayment made due to mathematical errors or otherwise,
          penalties incurred, Transaction related issues, issues related to
          Delivery, Customer Charge or Product, if the Transaction was not made
          in accordance with the requirements of PayCraft and/or the Acquiring
          and/or Issuing Banks and/or Card Association. In the event of
          rejection of payment with respect to Customer Charge, Chargeback,
          refunds or other Outstanding Amounts due to PayCraft, Acquiring and/or
          Issuing Bank, PayCraft and/or the Acquiring and/or Issuing Bank
          reserve the right to reverse the given to the Customer or Vendor or
          Vendors Bank Account or set-off the payment amount rejected,
          Chargeback or refunded or the Outstanding Amount against Settlement
          Amount payable to the Vendor or Vendors or Customer or utility service
          provider. PayCraft and/or Acquiring and/or Issuing Banks may also
          deduct the payment amount due from future Settlement Amounts payable
          to the Vendor or Vendors or Customer with respect to subsequent
          Transactions and/or ask to pay before any future transaction
          processing. All Settlement Amount due to the Vendor(s), Customer or
          utility service provider may be suspended or delayed till such time as
          PayCraft, the Acquiring and/or Issuing Banks and/or Nodal Bank deems
          fit, if (a) the Customer or a third party commits any fraud or
          violates any law or legal requirement;{" "}
        </p>
        <p className="query_section">
          <ol type="1" style={{ paddingLeft: "40px" }}>
            <li>
              PayCraft and/or the Acquiring and/or Issuing Banks have reasons to
              believe that a fraud has been committed by the Customers,
            </li>
            <li>
              The Customer has excessive pending Chargebacks or poses high
              Chargeback and/or refund Risk; or
            </li>
            <li>for any other reasonable reasons.</li>
          </ol>
        </p>
        <p>
          PayCraft reserves the right to reject or de-board any Vendor/service
          provider found violating Acquiring/Issuing bank norms & guidelines
          and/or for OFAC/Sanctions/AML purposes.{" "}
        </p>
        <p>9. Authorization And Authentication Of Transaction </p>
        <p>
          The PayCraft, Acquiring and/or Issuing Banks and/or Card Association
          has the right to reject authorization of Transaction placed by the
          Customer for any reason including but not limited to risk management,
          suspicion of fraudulent, illegal or doubtful Transactions, selling of
          banned items, use of compromised Valid Cards, use of
          blacklisted/banned cards or in accordance with the RBI, Acquiring
          Banks, Issuing Institution and/or Card Association rules, guidelines,
          regulations, etc and any other Applicable Laws, rules, regulations,
          guidelines in force in India, etc. PayCraft and/or the Acquiring
          and/or Issuing Banks reserve the right to limit or restrict
          transaction size, amount and/or monthly volume at any time. For the
          purpose of clarity such limitations or restrictions may be imposed for
          the following reasons including but not limited to limits/restrictions
          on the number of purchases which may be charged on an individual Valid
          Card or net banking account during any time period, unusual monetary
          value of Transaction, etc. Further, PayCraft may at its sole
          discretion block any card number, account numbers, group of cards or
          Transactions from any specific blocked or blacklisted Customer cards,
          accounts, specific, group of IP addresses, devices, geographic
          locations and / or any such risk mitigation measures it wishes to
          undertake.{" "}
        </p>
        <h4>Right/Title/Interest & Ownership</h4>
        <p>
          PayCraft reserves and retains all of its right, title, and interest in
          and to the services connected to the PayCraft Platform, and all its
          copyrights, patents, trademarks, service marks, design rights (whether
          registered or unregistered), trade secrets, know-how, expertise, and
          all other similar proprietary rights associated therewith, including
          the trademark ‘PayCraft’ ("Intellectual Property Rights") and/or which
          are developed in connection with the PayCraft Services and PayCraft
          Platform, or already developed. PayCraft does not convey any
          proprietary rights or other interest therein to Customer. Customer has
          a non-exclusive, revocable and a limited access to use PayCraft
          Platform but cannot reproduce, communicate, modify or reverse engineer
          the PayCraft Platform. Customer must not copy or allow any third party
          an access to the PayCraft Platform without prior written consent from
          PayCraft. Customer understands that PayCraft is in no way transferring
          or assigning its Intellectual Property Rights in PayCraft Platform or
          any of its other products and services to the Customer or any other
          party as they shall remain the exclusive property of the PayCraft.
          Upon termination of Customer’s engagement with PayCraft for whatsoever
          reasons, the Customer will deliver and return to PayCraft all
          documents, samples, and other materials which may have been provided
          by PayCraft in connection with the PayCraft Platform or the Services.{" "}
        </p>
        <h4>Privacy</h4>
        <p>
          Any information that the Customer provides to PayCraft or on the
          PayCraft Platform is subject to the Privacy Policy, which governs the
          collection and use of Customer information.{" "}
        </p>
        <h4>Limitation Of Liability</h4>
        <p>
          Notwithstanding anything stated herein, the aggregate liability of
          PayCraft to the Customer from any cause whatsoever shall not in any
          event exceed the sum equivalent to the Service Fee earned by PayCraft
          from the Transactions undertaken by the Customer on the PayCraft
          Platform, during the month preceding the date of occurrence of such
          liability. Provided that PayCraft shall not be liable to the Customer
          for any special, incidental, indirect or consequential damages,
          damages from loss of profits or business opportunities even if
          PayCraft has been advised in advance of the possibility of such loss,
          cost or damages. In no event shall the Nodal Bank or the Acquiring
          and/or Issuing Bank be liable to the Customer in any way. In no event
          will PayCraft be liable for any loss of profits, revenues, business
          opportunities, exemplary, punitive, special, incidental, and indirect
          or consequential damages. PayCraft will not be liable for any loss,
          expenses or damage whatsoever caused by:{" "}
        </p>
        <p className="query_section">
          <ol type="1">
            <li>
              Failure for whatever reason of a card issued by PayCraft or any
              Equipment or the system to function properly or at all; or
            </li>
            <li>
              Unauthorized acquisition of information by any person through
              other Customers on the Platform or other interception of
              communication on the system PayCraft Platform;
            </li>
            <li>
              PayCraft will not entertain any requests of Chargeback from the
              Customer or Issuing Institution;
            </li>
            <li>
              Any trade related dispute between Customer or Customer's Vendors
              or Customers service provider; will be settled outside the purview
              of these terms.
            </li>
          </ol>
        </p>
        <h4>Confidential Information </h4>
        <p>
          The Customer will, at all times, maintain confidentiality regarding
          all Confidential Information received by it through the access to the
          PayCraft Platform or use of PayCraft Services. The Customer agrees to
          protect the proprietary information with the same standard of care and
          procedures used by themselves to protect their own proprietary
          information of similar importance but at all times and at least a
          reasonable degree of care.{" "}
        </p>
        <p className="query_section">
          <ol type="1">
            <li>
              The Customer shall not be liable for disclosure or use of any
              Confidential Information if the same:
            </li>
            <li>
              Was at the time received or which thereafter becomes, through no
              act or failure on the part of the Customer, generally known or
              available to the public;{" "}
            </li>
            <li>
              Is known to the Customer at the time of receiving such information
              as evidenced by documentation then rightfully in the possession of
              the Customer and to which no confidentiality exists;
            </li>
            <li>
              Is furnished to others by the Customer without restriction of
              disclosure;{" "}
            </li>
            <li>
              Has been disclosed pursuant to the requirements of law or court
              order without restrictions or other protection against public
              disclosure; provided, however, that PayCraft shall have been given
              a reasonable opportunity to resist disclosure and/or to obtain a
              suitable protective order.{" "}
            </li>
          </ol>
        </p>
        <h4>Links</h4>
        <p>
          There may be links to third-party websites or resources on the
          Platform. Customer acknowledges and agrees that PayCraft is not
          responsible or liable for: The availability or accuracy of such
          websites or resources; or the content, products, or services on or
          available from such websites or resources. Links to such websites or
          resources do not imply any endorsement by the PayCraft of such
          websites or resources or the content, products, or services available
          from such websites or resources. Customer acknowledges sole
          responsibility for and assumes all risk arising from your use of any
          such websites or resources.
        </p>
        <h4>Disclaimer</h4>
        <p className="query_section">
          <ol type="1">
            <li>
              Customers acknowledge and agree that their use of the PayCraft
              Platform is at their own risk and that the PayCraft Platform is
              provided on an “as is” and “as available” basis.{" "}
            </li>
            <li>
              However, notwithstanding anything herein, the Customer
              acknowledges that PayCraft Platform, PayCraft Services, and the
              Acquiring and/or Issuing Bank's Services may not be uninterrupted
              or error-free or free from any virus or other malicious,
              destructive or corrupting code, program, or macro, and PayCraft
              and the Acquiring and/or Issuing Banks disclaim all warranties,
              express or implied, written or oral, including but not limited to
              warranties of non-infringement, merchantability, and fitness of
              the services for a particular purpose.{" "}
            </li>
            <li>
              The Customer also acknowledges that the arrangement between one or
              more Acquiring and/or Issuing Banks and PayCraft may terminate at
              any time and services of such Acquiring and/or Issuing Banks may
              be withdrawn.{" "}
            </li>
            <li>
              PayCraft does not warrant or endorse the effectiveness, quality,
              or safety of the PayCraft Services available on the PayCraft
              Platform.{" "}
            </li>
            <li>
              Although PayCraft adopts security measures, it considers
              appropriate for the offer of the PayCraft Service, it does not
              assure or guarantee that no person will overcome or subvert the
              security measures and gain unauthorized access to the PayCraft
              Service or the Customer data. PayCraft shall not be responsible or
              liable if any unauthorized person hacks into or gains access to
              the PayCraft Service or to the Customer's PayCraft Account. In the
              event of incorrect settlement in the Customer's Account due to an
              error on the part of PayCraft or the Bank, PayCraft shall have the
              right to reverse the extra funds from the Customer/Vendor Bank
              Account. In addition, the Customer and/or its Vendor/Vendors shall
              be fully liable to return the extra funds settled within 7 (seven)
              days of intimation by PayCraft.{" "}
            </li>
            <li>
              Customer acknowledges and agrees that PayCraft will have no
              liability for any:{" "}
              <ul style={{ paddingLeft: "40px" }}>
                <li>
                  errors, mistakes, or inaccuracies of any content available on
                  PayCraft Platform.{" "}
                </li>
                <li>
                  personal injury, property damage, or other harm resulting from
                  your access to or use of the PayCraft Platform.{" "}
                </li>
                <li>
                  any unauthorized access to or use of PayCraft servers, any
                  personal information, or user data or any interruption of
                  transmission to or from the PayCraft Platform.{" "}
                </li>
                <li>
                  any bugs, viruses, trojan horses, or the like that may be
                  transmitted on or through the PayCraft Platform; or any
                  damages, losses, costs, expenses, or liabilities of any kind
                  incurred because of any Transaction performed through the
                  PayCraft Platform.
                </li>
              </ul>
            </li>
            <li>
              PayCraft shall not be responsible for the non-availability of the
              PayCraft Services during periodic maintenance operations or any
              unplanned suspension of access to PayCraft Services that may occur
              due to technical reasons or for any reason beyond PayCraft’s
              control.{" "}
            </li>
            <li>
              In addition, PayCraft shall not be liable to the Customer for any
              loss or damage whatsoever or howsoever caused or arising, directly
              or indirectly, including without limitation, as a result of the
              loss of data; interruption or stoppage of the Customer's access to
              and/or use of the PayCraft Platform, PayCraft Services, and/or the
              Payment Mechanism, hacking, or unauthorized access to the PayCraft
              Services, or PayCraft Platform, non-availability of connectivity
              between the Customer Systems and PayCraft Platform, etc. Any
              material/information downloaded or otherwise obtained through the
              use of the PayCraft Services is done at the Customer's discretion
              and risk, and the Customer and its Vendor's will be solely
              responsible for any damage to its computer system or loss of data
              that results from the download of any such material. No advice or
              information, whether oral or written, obtained by the Customer
              from PayCraft or through or from the use of PayCraft Services
              shall create any warranty. PayCraft shall have no liability in
              this respect.{" "}
            </li>
            <li>
              PayCraft's sole obligation and the Customer's sole and exclusive
              remedy in the event of an interruption in the PayCraft Platform or
              loss of use and/or access to PayCraft Platform, if any, will be to
              use all reasonable endeavours to repair and restore the PayCraft
              Services and/or access to the Payment Mechanism as soon as
              reasonably possible.{" "}
            </li>
            <li>
              ept as expressly set forth above and to the extent permitted by
              applicable law, PayCraft makes no warranty of any kind, express,
              implied, or statutory, regarding the services or software, and all
              such warranties, including without limitation the implied
              warranties of customer's ability, fitness for a particular
              purpose, and non-infringement, are hereby expressly disclaimed by
              PayCraft.{" "}
            </li>
            <li>
              Craft will not entertain any requests of Chargeback from the
              Customer or Issuing Institution.{" "}
            </li>
          </ol>
        </p>
        <h4>Indemnity:</h4>
        <p className="query_section">
          <ol type="1">
            <li>
              Customer shall indemnify and keep indemnified PayCraft, and its
              directors, affiliates, employees, and agents against any loss or
              costs, charges and expenses required to be incurred or suffered by
              PayCraft (including attorney's and expert witnesses’ costs and
              fees) arising out of any obligation of the Customer due to any act
              or omission or breach which is attributable to Customer.{" "}
            </li>
            <li>
              The Customer hereby undertakes and agrees to indemnify, defend and
              hold harmless PayCraft for violations of Anti Money Laundering
              regulations.{" "}
            </li>
            <li>
              The Customer hereby undertakes and agrees to indemnify, defend and
              hold harmless PayCraft and/or the Acquiring and/or Issuing Banks
              including their officers, directors and agents from and against
              all actions, proceedings, claims (including third party claims),
              liabilities (including statutory liability), penalties, demands
              and costs (including without limitation, legal costs), awards,
              damages, losses and/or expenses however arising directly or
              indirectly, including but not limited to, as a result of:{" "}
            </li>
            <li>
              Breach or non-performance by the Customer of any of its
              undertakings, warranties, covenants, declarations or obligations
              under these Terms and Conditions.{" "}
            </li>
            <li>
              Breach of confidentiality and intellectual property rights
              obligations by the Customer.{" "}
            </li>
            <li>
              {" "}
              Any act, deed, negligence, omission, misrepresentation, default,
              misconduct, non-performance or fraud by the Customer, its
              employees, contractors, agents.{" "}
            </li>
            <li>
              Chargebacks or refunds relating to the Transactions contemplated
              under these Terms and Conditions.{" "}
            </li>
            <li>
              Breach of law, rules regulations, legal requirements (including
              RBI regulations, Card Association Rules, Acquiring and/or Issuing
              Bank rules) in force in India and/or in any place from where the
              Customers is making the Transaction and/or where the Product is or
              to be Delivered and/or where the respective Issuing Institution is
              incorporated/registered/established; or{" "}
            </li>
            <li>
              Any fines, penalties or interest imposed directly or indirectly on
              PayCraft on account of Customer's or Transactions conducted
              through Customer under these Terms and Conditions.{" "}
            </li>
          </ol>
        </p>
        <h4>Suspension and Termination</h4>
        <p className="query_section">
          <ol type="1">
            <li>
              The Terms will continue to apply until terminated by either the
              Customer or PayCraft as set forth below. If you object to the
              Terms or are dissatisfied with the PayCraft Services, your only
              recourse is to{" "}
              <ul style={{ paddingLeft: "40px" }}>
                <li>close your Account; and </li>
                <li>stop accessing the PayCraft Services. </li>
              </ul>
            </li>
            <li>
              {" "}
              PayCraft reserves the right to terminate, discontinue, suspend,
              limit, or restrict your account or your use of the PayCraft
              Services or access to PayCraft Platform at any time, without
              notice or liability, if PayCraft so determines in its sole
              discretion, for any reason whatsoever. Additionally, PayCraft
              reserves the right to delist you or block your future access to
              the PayCraft Service or suspend or terminate your Account if it
              believes, in its sole discretion that you have infringed,
              breached, violated, abused, or unethically manipulated or
              exploited any term of these Terms or anyway otherwise acted
              unethically.{" "}
            </li>
            <li>
              If you or PayCraft terminates your use of the PayCraft Services,
              PayCraft may, subject to the terms of the Privacy Policy, delete
              any information relating to your use of the PayCraft Service, and
              PayCraft will have no liability to you or any third party for
              doing so.{" "}
            </li>
          </ol>
        </p>
        <h4>Governing Law, Jurisdiction and Dispute Resolution </h4>
        <p className="query_section">
          <ol type="1">
            <li>
              The provisions of these Terms and Conditions shall be governed by
              and construed in accordance with Indian law.
            </li>
            <li>
              Any dispute, controversy or claims arising out of or relating to
              these Terms and Conditions or the breach, termination or
              invalidity thereof, shall be settled by arbitration at Mumbai, in
              accordance with the provisions of the Indian Arbitration and
              Conciliation Act, 1996. The arbitral tribunal shall be composed of
              a Sole Arbitrator to be appointed by PayCraft.{" "}
            </li>
          </ol>
        </p>
        <h4>General Terms</h4>
        <p className="query_section">
          <ol type="1">
            <li>
              <strong>Waiver and Severability</strong> The failure of PayCraft
              to enforce any right or provision of these Terms will not be
              deemed a waiver of such right or provision. If any provision of
              these Terms is held to be invalid or unenforceable, then that
              provision will be limited or eliminated to the minimum extent
              necessary, and the remaining provisions of these Terms will remain
              in full force and effect.
            </li>
            <li>
              <strong>Entire Agreement</strong>
              <p className="query_section">
                <ol
                  type="1"
                  // class="lower-roman-nested"
                  style={{ paddingLeft: "40px" }}
                >
                  <li>
                    These Terms, the Privacy Policy and other policies available
                    on the PayCraft Platform are the entire and exclusive
                    agreement between PayCraft and Customer regarding the
                    PayCraft Service (excluding any services for which you have
                    a separate agreement with PayCraft that is explicitly in
                    addition or in place of these Terms), and these Terms
                    supersede and replace any prior agreements between PayCraft
                    and you regarding the Services.
                  </li>
                  <li>
                    PayCraft retains the unconditional right to revise these
                    Terms from time to time, the most current version will
                    always be on the Platform. You can determine when this Terms
                    was last modified by referring to the “Last Updated” legend
                    above. It shall be your responsibility to check this Terms
                    periodically for changes. Your continued use and access of
                    the Service shall signify your acceptance of the amended
                    Terms and your consent to be legally bound by the same.
                  </li>
                </ol>
              </p>
            </li>
            <li>
              <strong>Grievance Redressal</strong>
              <p className="query_section">
                <ol
                  type="1"
                  // class="lower-roman-nested"
                  style={{ paddingLeft: "40px" }}
                >
                  <li>
                    Any complaints arising from the use of the PayCraft Service
                    may be addressed to the following: In the event of any
                    dispute or grievance in relation to the Transaction and/or
                    these Terms and Conditions, the User may contact the
                    customer care center at{" "}
                    <a href="mailto:nodalofficer@nsdlbank.co.in">
                      nodalofficer@nsdlbank.co.in
                    </a>
                    and [022-42022190].
                  </li>
                  <li>
                    The Grievance Redressal Officer shall, upon receiving the
                    complaint initiate inquiry into the same and shall endeavor
                    to resolve the complaint promptly, in accordance with the
                    Applicable Laws.
                  </li>
                </ol>
              </p>
            </li>
          </ol>
        </p>
      </div>
    ),
  },
  {
    label: "Flow of transaction / User Journey for Top Up",
    key: "Flow of transaction / User Journey for Top Up",
    children: (
      <div className="policy_section terms_policy">
        <h3 className="policy_header">
          Flow of transaction / User Journey for Top Up
        </h3>
        <p className="query_section">
          <ol type="1">
            <li>
              The Users can conveniently top-up, load, or re-load their Cards by
              providing the details of the card and the desired recharge amount
              through our secure online Platform.
            </li>
            <li>
              The first-time User must create an account at our Platform
              (“Account”). Pursuant to creating an Account, you may log-in to
              the Account and avail various services provided at the Platform.
            </li>
            <li>
              The process for loading value onto the Cards shall be as follows:
              <ul style={{ paddingLeft: "30px" }}>
                <li>
                  To load or reload value on the Card, the User must log-in to
                  the Account and provide details of card and value of desired
                  amount to be loaded or reloaded to the Card at the Platform.
                  The User has the option to utilize any Payment Channel for
                  loading or reloading the Card. By submitting the Card and
                  other relevant details on the Platform, the User acknowledges
                  that it serves as an instruction and consent from the User to
                  Us, authorizing the initiation of the Transaction.{" "}
                </li>
                <li>
                  Upon receiving the User's instruction, our system will
                  automatically initiate the Transaction and send a request to
                  the Issuer for Transaction authentication.{" "}
                </li>
                <li>
                  Once the Transaction is successfully authenticated by the
                  Issuer and the Payment Channel Service Provider has processed
                  the Transaction, the requested value will be loaded or
                  reloaded onto your Card.
                </li>
              </ul>
            </li>
          </ol>
        </p>
      </div>
    ),
  },
  {
    label: "Privacy Policy",
    key: "3",
    children: (
      <div className="policy_section privacy_policy">
        <h3 className="policy_header">Privacy Policy</h3>

        <p>
          PayCraft Solutions Private Limited, a company under the Companies Act,
          2013, having its registered office at B-1103/1104 Kailash Business
          Park, Kailash Complex, Ghatkopar – Powai Link Road, Park Site,
          Vikhroli (West), Mumbai – 400079, Maharashtra, India (“Paycraft”).
          PayCraft owns, manages, and operates the mobile application and
          website available at https://www.paycraftsol.com/ (“PayCraft
          Platform”) to facilitate and offer a vast repository of dining
          experiences and deals, gift cards, and corporate benefit cards
          (“Services”) to the user of the PayCraft Platform (collectively
          referred to as “user” or “users” or “you” or “your”). PayCraft
          respects the privacy of its users and is committed to protect it in
          all respects. With a view to offer the most enriching and holistic
          experience to its users, PayCraft offers a vast repository of Services
          including dining experiences and deals, gift cards, and corporate
          benefit cards.
        </p>

        <p>
          This Privacy Policy delineates the objectives and methodologies
          governing the processing of your information by us and the use of our
          Services/Paycraft Platform by you. You must agree to this policy as a
          condition of accessing or availing the Service. If you do not agree to
          these Terms, you may not access or avail the Services. By accessing or
          availing of the Services or by clicking on “I Accept”, you hereby
          confirm to have explicitly read, understood, and accepted this policy
          and give your consent to collect, store, process, use, or transfer
          your information by the Company, without limitation or qualification,
          in accordance with the applicable law.
        </p>

        <p>
          Please be advised that our detailed Privacy Policy is accessible on{" "}
          <a href="https://emsweb.paycraftsol.com">
            https://emsweb.paycraftsol.com
          </a>
          . The key provisions of our Privacy Policy have been integrated herein
          for your convenience. We encourage our users to carefully review the
          complete Privacy Policy before granting their consent.
        </p>

        <p>
          The information about the user as collected by PayCraft is as follows:
        </p>

        <ol className="query_section">
          <li>Information supplied by users.</li>
          <li>
            Information automatically tracked while using PayCraft’s Platform or
            availing the Services products. By using PayCraft’s Platform website
            or its services, you consent to the collection, storage, and use of
            the personal information including the personal data that you
            provide (including any changes thereto as provided by you) for
            availing any of the Services that we offer.
          </li>
        </ol>

        <h4>User Information</h4>

        <p>
          To avail certain sites/services on Paycraft Platform our websites,
          users are required to provide certain information for the registration
          process that may include but not limited to the following:
        </p>

        <ol className="query_section">
          <li>Name</li>
          <li>Age</li>
          <li>Email</li>
          <li>PIN code</li>
          <li>Credit or Debit Card Details</li>
          <li>Biometric Information</li>
          <li>Passwords</li>
          <li>Cardholder’s occupation, interests</li>
        </ol>

        <p>
          The Information as supplied by the users enables us to improve
          Paycraft Platform our sites and provide you the most user-friendly
          experience. All required information is service-dependent and PayCraft
          may use the above said user information to, maintain, protect, and
          improve its services (including advertising services) and for
          developing new services.
        </p>

        <p>
          Such information will not be considered as sensitive if it is freely
          available and accessible in the public domain or is furnished under
          the Right to Information Act, 2005, any rules made there under, or any
          other law for the time being in force. Kindly refer to the Privacy
          Policy of Paycraft, available at{" "}
          <a href="https://emsweb.paycraftsol.com">
            https://emsweb.paycraftsol.com
          </a>
          , for more details on use of your information by us.
        </p>

        <h4>Cookies</h4>

        <p>
          To improve the responsiveness of the sites for our users, we may use
          “cookies”, or similar electronic tools to collect information to
          assign each visitor a unique, random number as a user identification
          (User ID) to understand the user’s individual interests using the
          identified computer.
        </p>

        <p>
          Unless you voluntarily identify yourself (through registration, for
          example), we will have no way of knowing who you are, even if we
          assign a cookie to your computer. The only personal information a
          cookie can contain is information you supply (an example of this is
          when you ask for deals in a certain location). A cookie cannot read
          data off your hard drive.
        </p>

        <p>
          Our advertisers may also assign their own cookies to your browser (if
          you click on their ads), a process that we do not control.
        </p>

        <p>
          Our web servers automatically collect limited information about your
          computer’s connection to the Internet, including your IP address, when
          you visit our site. Your IP address does not identify you personally.
          We use this information to deliver our web pages to you upon request,
          to tailor our site to the interests of our users, to measure traffic
          within our site, and to let advertisers know the geographic locations
          from where our visitors come.
        </p>

        <h4>Link To Third Party Sites</h4>

        <p>
          PayCraft Platform includes links to third-party other websites. Such
          third-party sites are governed by their respective privacy policies,
          which are beyond our control. Once you leave our servers, the use of
          any information you provide is governed by the privacy policy of the
          operator of the third-party website you are visiting.
        </p>

        <p>
          We may share or transfer your information to our advertisers. When we
          present information to our advertisers, it is usually in the form of
          aggregated statistics.
        </p>

        <h4>Information Sharing</h4>

        <ol className="query_section">
          <li>
            When it is requested or required by law or by any court or
            governmental agency or authority.
          </li>
          <li>
            PayCraft proposes to share such information within its group
            companies and officers and employees for processing personal
            information.
          </li>
        </ol>

        <h4>Accessing and Updating Personal Information</h4>

        <p>
          In case you wish to correct or remove your information, you may send a
          request for the same to info@paycraftsol.com.
        </p>

        <h4>Information Security</h4>

        <p>
          We take appropriate security measures to protect against unauthorized
          access, alteration, disclosure, or destruction of data.
        </p>

        <h4>Complaints or Concerns</h4>

        <p>
          Any complaints or concerns may be addressed to
          support@paycraftsol.com.
        </p>

        <h4>Privacy Policy Changes</h4>

        <p>
          By agreeing to use the PayCraft Platform or the Services, you accept
          this Privacy Policy. Paycraft reserves the right to make changes to
          this Privacy Policy. Your continued use constitutes acceptance of the
          updated policy.
        </p>
      </div>
    ),
  },
  {
    label: "Refund Policy",
    key: "refund_policy",
    children: (
      <div className="policy_section refund_policy">
        <h3 className="policy_header">Refund Policy</h3>
        <p className="query_section">
          <ul>
            <li>
              Cancellation and refunds are not applicable on Virtual/E-Gift
              Cards{" "}
            </li>
            <li>
              Physical Gift Cards can be cancelled as long as they have not been
              dispatched by us.{" "}
            </li>
            <li>
              Refund will be processed within 5-7 working days post cancellation
              request being formally received by the PayCraft
              Operations/Customer Support team.{" "}
            </li>
            <li>
              Expired Gift Cards are not redeemable, and Gift Card amounts will
              not be refunded or credited when expired into the recipient/card
              holder’s bank Account.{" "}
            </li>
            <li>
              Lost/Expired card Revalidation/Reissuance requests will be
              honoured as per the policies outlined in the terms and conditions
              documents.{" "}
            </li>
            <li>
              Physical Gift Cards and virtual/e-Gift Cards can’t be exchanged
              for cash.{" "}
            </li>
          </ul>
        </p>
      </div>
    ),
  },
  {
    label: "FAQs",
    key: "faqs",
    children: (
      <div className="policy_section faqs_section">
        <h3 className="policy_header">FAQs for Use of PayCraft Products</h3>

        <p>
          Q. What is the One Nation One Corporate Card Transit Enabled Employee
          Benefits Card?
        </p>
        <p>
          A. The One Nation One Corporate Card is an Employee Benefits Card, a
          Multi-wallet Reimbursement card is a Reimbursement card which has five
          wallets, namely: Meal, Fuel, Corporate Reimbursements, Gift, Business
          Expense Wallet and Transit Wallet (if opted for) Each wallet can be
          used at respected merchant categories as:
        </p>

        <p>1. Meal Wallet - Food Outlets and Restaurants</p>
        <p>2. Fuel Wallet - Fuel Pumps and Fuel Stations</p>
        <p>
          3. Corporate Reimbursement Wallet - Other corporate benefits such as
          Internet, Mobile and Landline Service Providers
        </p>
        <p>
          4. Expense Wallet - Enabled with Cash Withdrawal and business expenses
          (advances and reimbursements) which is linked to One Nation One
          Corporate Card's Business Expense Management Platform.
        </p>
        <p>
          5. Transit Wallet - Card holder/Corporate funded Wallet (via UPI/PG)
          to fund a dedicated transit wallet designed to work on all enabled
          Metro systems in India.
        </p>

        <p>
          Each wallet can only be used at its designated merchants and for up to
          the amount loaded in that wallet. For instance, an amount loaded in
          the Meal Wallet can only be used at Meal Merchant and not any other
          merchant category.
        </p>
        <p>
          • Note: Cash Withdrawal enabled for the Expense and Reimbursement
          Wallets only. ATM withdrawals are possible in all ATMS of any Bank pan
          India. All ATM charges as per actual and will be debited from the
          Expense or Reimbursement Wallets.
        </p>

        <p>Q. How is the One Nation One Corporate Card used?</p>
        <p>
          A. The One Nation One Corporate Card Employee Benefits Card being a
          swipe card just like any other debit/credit card can be used at the
          point of sale at the merchant store by simply swiping it and entering
          the POS PIN. The One Nation One Corporate Card Employee Benefits Card
          can also be used online.
        </p>

        <p>
          Q. For how much amount can the One Nation One Corporate Card Employee
          Benefits Card be swiped for at the Merchant Store?
        </p>
        <p>
          A. The One Nation One Corporate Card can be used for any amount up to
          the amount loaded on the wallet on the respective merchants. This
          means that if the Meal Wallet is loaded with a certain amount, the
          user can use the amount up to the available amount at a Food outlet.
          The other wallets will work similarly. The card can be used only until
          the validity period.
        </p>

        <p>
          Q. Can the balance in one wallet be used at merchants other than the
          ones belonging to the category?
        </p>
        <p>
          A. No, the balance in each wallet can only be used in a merchant of
          the corresponding category. For example, the balance in the Meal
          Wallet can only be used at Food outlets, Fuel Wallet can only be used
          at Fuel outlets etc. If your card does not have balance in the Meal
          wallet but has balance in the Fuel, then the card would be declined at
          Food outlets
        </p>

        <p>
          Q. Can the balance in one wallet be transferred into another wallet?
        </p>
        <p>
          A. No, the balance in each of the wallets cannot be transferred into
          any other wallet
        </p>

        <p>Q. What is OTP, POS PIN and where is it used?</p>
        <p>
          A. Open Canvas provides system generated/user generated green pin
          options. The card holder or issuer can generate a set of PINs
          (POS/ATM) on completion of card activation. The OTP is used for
          verifying and validating online – ECOM - purchases and the POS PIN is
          used for verifying and validating POS transactions.
        </p>

        <p>Q. How to I check when the card will expiry?</p>
        <p>A. The card expiry date is printed on the front of the card.</p>

        <p>Q. Can we use this card online for E-COM?</p>
        <p>
          A. The One Nation One Corporate Card can be used at online merchants.
          Each wallet can be used online for E-Com transactions on the
          respective merchant. Additionally, this card along with balances in
          the meal wallet and the expense wallet can be used for ordering food
          online through online food delivery services like Zomato and Swiggy.
        </p>

        <p>Q. How can I check the balance on my card?</p>
        <p>
          A. You can check the balance on your card by dialling Customer Care
          Number: +91 7400088941 or 022- 42022190 (Monday to Friday 10:00 AM to
          06:00 PM). You can also log onto the website
          https://paycraftsol.com/one_nation_corporate_card/ with your card
          number and an OTP sent to the registered mobile number and check the
          balance on your card.
        </p>

        <p>Q. How do I place an order online?</p>
        <p>
          A. Once you have selected your item, in the payment section select the
          debit card option and enter the 1. Card number 2. Expiry date 3. CVV
          number Next, enter the RuPay BEPG OTP for the second factor
          authentication
        </p>

        <p>Q. What happens if the card gets lost?</p>
        <p>
          A. Kindly call the customer support number printed at the back of the
          card and place a request to block and reissue the card. The customer
          support helpline number is available from 10:00 AM to 6:00 PM, Monday
          to Friday. You can also write an email to the email id mentioned at
          the back of the card requesting for blocking the card.
        </p>

        <p>Q. What is the fee for reissuing card?</p>
        <p>A. The fees for reissuance are Rs. 249/- plus GST applicable.</p>

        <p>Q. Can value be added to the One Nation One Corporate Card?</p>
        <p>
          A. The One Nation One Corporate Card will be loaded basis the
          instructions received from your company. You will be notified with an
          SMS alert when your card is loaded.
        </p>

        <p>
          Q. Can the Card be used if its Available Balance does not cover the
          total purchase price?
        </p>
        <p>
          A. The Card cannot be used to make transactions that exceed the
          available balance on the wallet. For such a transaction you need to
          pay the difference by another method if the merchant agrees.
        </p>
      </div>
    ),
  },
  {
    label: "About Product",
    key: "about_product",
    children: (
      <div className="policy_section about_product">
        <h3 className="policy_header">About Product</h3>
        <p className="query_section">
          PayCraft is providing its Business Expense Management Solution for
          Corporates and there is also a provision to opt for the multi-wallet
          Prepaid Expense Card for various payments on Ecom, POS, ATM and
          Transit. The Prepaid Expense Card offered to the Corporate Employees
          is a multi-wallet card which can be used across different digital
          payment channels as well as for Urban Mobility like Metro Rails and
          can also work as a Tax Benefit solution with its Meal and Fuel wallet
          options. To summarize it is a All-in-One Card completely aligned to
          the vision of empowering India with One Nation One Card. A one of its
          kind, this card can be used at multiple merchant locations, can be
          used as a tax benefit solution and can also be used for travel by the
          Metros or Buses. This platform enables loading / reloading of the
          Transit or personal wallets created on these Prepaid Expense Card by
          individual cardholders who have been offered this card.
        </p>
      </div>
    ),
  },
  {
    label: "About us",
    key: "7",
    children: (
      <div className="policy_section terms_policy">
        <h3 className="policy_header">About us</h3>
        <p className="query_section">
          Paycraft is a payments company providing contactless open loop
          products with capabilities of processing online and offline
          transactions. We cover a plethora of use cases demanding transaction
          processing time within milli-seconds thereby simplify ticketing,
          validation and management for program operators. Founded in 2013 with
          an aim to enable and ease urban mobility, PayCraft is one of the
          leading solution providers for Banks and Public Transport Operators.
          With its Common Mobility Card Solutions, PayCraft is one of the
          leading solution providers offering open loop transport solutions
          which combines the technologies of Banking and Transport worlds to
          offer a convenient travel experience to daily urban traveller. We work
          with world’s leading payment schemes, banks, transport operators and
          device manufacturers to enable multi-party digital Ecosystem{" "}
        </p>
      </div>
    ),
  },
  {
    label: "Cancellation",
    key: "Cancellation",
    children: (
      <div className="policy_section terms_policy">
        <h3 className="policy_header">Cancellation</h3>
        <p className="query_section">
          <ol type="1">
            <li>
              The User may request the cancellation of their top-up, loading, or
              reloading request by reaching out to our customer support team at{" "}
              <a href="mailto:prepaid.service@nsdlbank.co.in">
                prepaid.service@nsdlbank.co.in
              </a>{" "}
              within a specified timeframe. The request for cancellation must be
              made before the Transaction is successfully processed.{" "}
            </li>
            <li>
              The User must provide valid transaction and identification details
              for processing of cancellation request.{" "}
            </li>
            <li>
              In the event of a transaction failure, an instant refund will be
              processed to your designated Source Account, provided the
              Transaction was made using a credit card or debit card at our
              Platform.{" "}
            </li>
            <li>
              If the top-up, loading, or reloading process has already been
              initiated and the Transaction is in progress, the cancellation
              request shall not be entertained. In such cases, the funds will be
              credited to the Card balance as per the successful Transaction.{" "}
            </li>
          </ol>
        </p>
      </div>
    ),
  },
];

const InfoNPolicy = () => {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div className="infoPolicy_section">
      <Tabs
        className="custom-tabs"
        defaultActiveKey="1"
        tabPosition={"top"}
        onChange={onChange}
        style={{ height: "650px", overflow: "auto" }}
      >
        {items.map((ele) => (
          <Tabs.TabPane
            tab={ele.label}
            key={ele.key}
            className="tab-bottom-color"
          >
            {ele.children}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};
export default InfoNPolicy;
